<template>
  <div class="qrcode-container">
    <div class="bg-decoration"></div>
    <div class="bg-decoration-2"></div>

    <div class="main-content">
      <div class="brand-section">
        <img src="https://img.moliaos.com/v/logo.png" class="brand-logo" alt="陌撩漂流瓶" />
        <h1 class="brand-title">陌撩漂流瓶</h1>
        <p class="brand-desc">遇见有趣的灵魂</p>
      </div>

      <div class="qrcode-card">
        <div class="qrcode-wrapper">
          <div class="qrcode-inner">
            <img :src="require('@/assets/QRCode.png')" class="qrcode-img" alt="下载二维码" />
          </div>
          <div class="qrcode-glow"></div>
        </div>

        <div class="qrcode-info">
          <div class="scan-badge">
            <i class="el-icon-mobile-phone"></i>
            <span>扫码下载</span>
          </div>
          <p class="info-title">陌撩漂流瓶</p>
          <p class="info-desc">安卓手机扫码即可下载安装</p>
        </div>
      </div>

      <div class="features-row">
        <div class="feature-item">
          <div class="feature-icon">
            <i class="el-icon-user-solid"></i>
          </div>
          <span class="feature-text">真实用户</span>
        </div>
        <div class="feature-item">
          <div class="feature-icon">
            <i class="el-icon-chat-dot-round"></i>
          </div>
          <span class="feature-text">趣味互动</span>
        </div>
        <div class="feature-item">
          <div class="feature-icon">
            <i class="el-icon-lock"></i>
          </div>
          <span class="feature-text">隐私保护</span>
        </div>
      </div>
    </div>

    <div class="bottom-bar">
      <span class="copyright">© 2026 陌撩漂流瓶</span>
    </div>
  </div>
</template>

<script>export default {
  name: 'QRCodePage'
}
</script>

<style scoped>
.qrcode-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #fff5f9 0%, #fff9ff 50%, #fdf2f8 100%);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bg-decoration {
  position: absolute;
  top: -150px;
  right: -150px;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(255, 96, 197, 0.15) 0%, transparent 70%);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

.bg-decoration-2 {
  position: absolute;
  bottom: -100px;
  left: -100px;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(186, 85, 211, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  animation: float 8s ease-in-out infinite reverse;
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(20px, 20px) scale(1.1);
  }
}

.main-content {
  width: 100%;
  max-width: 420px;
  padding: 60px 24px 40px;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.brand-section {
  text-align: center;
  margin-bottom: 40px;
}

.brand-logo {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(255, 96, 197, 0.3);
  margin-bottom: 16px;
  transition: transform 0.3s ease;
}

.brand-logo:hover {
  transform: scale(1.05);
}

.brand-title {
  font-size: 28px;
  font-weight: 700;
  color: #333333;
  margin-bottom: 8px;
  letter-spacing: 2px;
  background: linear-gradient(135deg, #ff60c5 0%, #ff85d1 50%, #a855f7 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.brand-desc {
  font-size: 15px;
  color: #888888;
}

.qrcode-card {
  width: 100%;
  background: #ffffff;
  border-radius: 28px;
  padding: 32px;
  box-shadow: 
    0 12px 40px rgba(255, 96, 197, 0.15),
    0 4px 16px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(255, 96, 197, 0.1);
  margin-bottom: 32px;
  position: relative;
}

.qrcode-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.qrcode-inner {
  position: relative;
  width: 220px;
  height: 220px;
  background: #ffffff;
  border-radius: 20px;
  padding: 12px;
  box-shadow: 
    0 8px 28px rgba(255, 96, 197, 0.2),
    inset 0 0 0 1px rgba(255, 96, 197, 0.1);
}

.qrcode-img {
  width: 100%;
  height: 100%;
  border-radius: 16px;
}

.qrcode-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 260px;
  height: 260px;
  background: radial-gradient(circle, rgba(255, 96, 197, 0.12) 0%, transparent 70%);
  border-radius: 50%;
  animation: pulse-glow 2s ease-in-out infinite;
}

@keyframes pulse-glow {
  0%, 100% {
    opacity: 0.5;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 0.8;
    transform: translate(-50%, -50%) scale(1.1);
  }
}

.qrcode-info {
  text-align: center;
  padding-top: 24px;
}

.scan-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #ff60c5 0%, #ff85d1 100%);
  color: #ffffff;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 16px;
  box-shadow: 0 4px 12px rgba(255, 96, 197, 0.35);
}

.scan-badge i {
  font-size: 15px;
}

.info-title {
  font-size: 20px;
  font-weight: 700;
  color: #333333;
  margin-bottom: 8px;
}

.info-desc {
  font-size: 14px;
  color: #999999;
}

.features-row {
  display: flex;
  justify-content: center;
  gap: 32px;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.feature-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, rgba(255, 96, 197, 0.1) 0%, rgba(255, 133, 209, 0.1) 100%);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #ff60c5;
  transition: all 0.3s ease;
}

.feature-icon:hover {
  transform: scale(1.1);
  background: linear-gradient(135deg, rgba(255, 96, 197, 0.2) 0%, rgba(255, 133, 209, 0.2) 100%);
}

.feature-text {
  font-size: 13px;
  color: #666666;
  font-weight: 500;
}

.bottom-bar {
  padding: 20px;
  text-align: center;
}

.copyright {
  font-size: 12px;
  color: #cccccc;
}

@media (max-width: 375px) {
  .main-content {
    padding: 48px 16px 32px;
  }

  .brand-logo {
    width: 68px;
    height: 68px;
  }

  .brand-title {
    font-size: 24px;
  }

  .brand-desc {
    font-size: 14px;
  }

  .qrcode-card {
    padding: 24px;
    border-radius: 22px;
  }

  .qrcode-inner {
    width: 180px;
    height: 180px;
    padding: 10px;
  }

  .qrcode-glow {
    width: 220px;
    height: 220px;
  }

  .features-row {
    gap: 24px;
  }

  .feature-icon {
    width: 42px;
    height: 42px;
    font-size: 20px;
  }
}

@media (max-height: 600px) and (orientation: landscape) {
  .main-content {
    padding: 32px 24px;
  }

  .brand-section {
    margin-bottom: 24px;
  }

  .brand-logo {
    width: 56px;
    height: 56px;
    margin-bottom: 10px;
  }

  .brand-title {
    font-size: 22px;
    margin-bottom: 4px;
  }

  .qrcode-card {
    padding: 20px;
    margin-bottom: 20px;
  }

  .qrcode-inner {
    width: 150px;
    height: 150px;
  }

  .qrcode-glow {
    width: 180px;
    height: 180px;
  }

  .features-row {
    gap: 20px;
    margin-bottom: 20px;
  }
}
</style>
